export default "./icons/LogoWhite.png";